export default {
  storeKeyName: "tour-website-",
  tokenTime: 60 * 60 * 6,
  tenantId: "019005",
};
